import { Component } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';

@Component({
  selector: 'compute-vcd',
  template: require('./compute-vcd.html')
})
export default class ComputeVCD {
  constructor(private translateService: TranslateService) {
    translateService.use(GlobalVariables.LOCALE);
  }
  ngOnInit() {
    console.log('init compute-vcd component');
  }
};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/compute-vcd.component.ts